import React from 'react'
import ShareCourse from '../../features/parentcounsellor/ShareCourse'

const ShareCoursePage = () => {
    return (
        <ShareCourse />
    )
}

export default ShareCoursePage